import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=0d8f321c&scoped=true&"
import script from "./TaskItem.vue?vue&type=script&lang=ts&"
export * from "./TaskItem.vue?vue&type=script&lang=ts&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=0d8f321c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f321c",
  null
  
)

export default component.exports